import React from 'react';
import BallIcon from '@material-ui/icons/FiberManualRecord';

const Ball = (props) => <BallIcon {...props} />;

export default Ball;
